var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({class:_vm.classNames,style:(_vm.iconStyles),attrs:{"title":_vm.title,"role":"presentation"}},_vm.$listeners),[_c('svg',[_c('use',{attrs:{"xlink:href":_vm.iconPath}})])])}
var staticRenderFns = []

export { render, staticRenderFns }